export enum Roles {
  Frontend = 'Front End',
  Novelty = 'Novelty',
  Reorder = 'Reorder',
  ReEngineering = 'Re-Engineering',
  MouldEngineering = 'Mould Engineering',
  Visitation = 'Visitation',
  Manager = 'Manager',
  ViewAll = 'View All',
}
